import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['panel', 'backdrop']

  connect() {
    requestAnimationFrame(() => {
      this.panelTarget.classList.remove('translate-x-full')
      this.backdropTarget.classList.remove('opacity-0')
    })
  }

  close(event) {
    event?.preventDefault()
    this.panelTarget.classList.add('translate-x-full')
    this.backdropTarget.classList.add('opacity-0')
    this.panelTarget.addEventListener('transitionend', () => {
      this.element.remove()
    }, { once: true })
  }

  keydown(event) {
    if (event.key === 'Escape') this.close()
  }

  backdropClick(event) {
    if (event.target === this.backdropTarget) this.close()
  }
}
